import { useLanguage } from '@/i18n/LanguageContext';
import { api } from '@/App';
import { toast } from 'sonner';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Globe } from 'lucide-react';

export default function LanguageSelector({ onLanguageChange }) {
  const { language, setLanguage, t } = useLanguage();

  const handleLanguageChange = async (newLang) => {
    if (newLang === language) return;
    
    try {
      // Update in backend
      await api.put('/auth/language', { language: newLang });
      
      // Update local state
      setLanguage(newLang);
      
      // Notify parent component
      if (onLanguageChange) {
        onLanguageChange(newLang);
      }
      
      toast.success(t('messages.languageChanged'));
    } catch (error) {
      console.error('Failed to update language:', error);
      toast.error(t('messages.operationFailed'));
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" data-testid="language-selector">
          <Globe className="h-4 w-4" />
          <span className="hidden sm:inline">{language === 'en' ? '🇬🇧 EN' : '🇩🇰 DA'}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('en')}
          className={language === 'en' ? 'bg-blue-50' : ''}
          data-testid="language-en"
        >
          🇬🇧 {t('language.english')}
        </DropdownMenuItem>
        <DropdownMenuItem 
          onClick={() => handleLanguageChange('da')}
          className={language === 'da' ? 'bg-blue-50' : ''}
          data-testid="language-da"
        >
          🇩🇰 {t('language.danish')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
